import React, {MouseEventHandler, useContext} from 'react';
import SearchFilters from "../../common/components/SearchFilters";
import {useTranslation} from "react-i18next";
import {GenericComponentModel, SelectElementModelBE, SelectElementModelFE} from "../../api/types/generic";
import {useRecoilState} from "recoil";
import {acrissOrderFiltersAtom} from "../../state/acrissOrder";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";

function AcrissOrderFilter({
                               handleClickResetSearch,
                               handleGetRateList,
                               testFilters,
                               setTestFilters
                           }: {
    handleGetRateList: MouseEventHandler<HTMLButtonElement>
    handleClickResetSearch: MouseEventHandler<HTMLButtonElement>
    testFilters: any
    setTestFilters: any
}) {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Recoil
    const [acrissOrderFilters, setAcrissOrderFilters] = useRecoilState(acrissOrderFiltersAtom);

    // Use Context
    const {
        globalData: {user},
    } = useContext(GlobalContext);

    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name))
        })
    );

    const optionsFiltered = legalEntityOptions
        .filter(function (el) {
            return el.code !== "all";
        });

    const filtersOutOfCollapse: GenericComponentModel[] = [
        {
            name: "legalEntities",
            value: testFilters.legalEntities as SelectElementModelFE,
            label: `Legal Entity`,
            handleChange: (value: SelectElementModelFE) =>
                setTestFilters({...testFilters, legalEntities: value}),
            options: optionsFiltered,
            type: "Autocomplete",
            hide: user.legalEntities.length === 1 ? true : false
        },
    ];
    const filtersInCollapse: GenericComponentModel[] = [];

    return (
        <SearchFilters
            filtersOutOfCollapse={filtersOutOfCollapse}
            filtersInCollapse={filtersInCollapse}
            handleClickSearch={handleGetRateList}
            handleClickResetSearch={handleClickResetSearch}
        />
    );
}

export default AcrissOrderFilter;